import { createCRUDHook } from './createCRUDHook';
import { PackagingScreenFilterDto, ReadyForPackagingDto } from 'utils/models';
import { PackagingStatusDto } from 'utils/models/packagingStatus.model';
import {
  INVOKE_ORDERS_READY_FOR_PACKAGING,
  TBL_CUSTOMER_ORDER,
  TBL_PACKAGING_ORDER_STATUS,
} from './apiEndPoints';
import { prepareQueryParams } from 'utils';

interface PackagingStatusCustomOperations {
  InvokeOrdersReadyforPackaging: (
    filters: PackagingScreenFilterDto
  ) => Promise<ReadyForPackagingDto[]>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  PackagingStatusDto,
  PackagingStatusDto[],
  PackagingStatusCustomOperations
>({
  entityName: 'PackagingStatus',
  endpoint: TBL_PACKAGING_ORDER_STATUS,

  customOperations: (auth) => ({
    InvokeOrdersReadyforPackaging: async (
      filters: PackagingScreenFilterDto
    ): Promise<ReadyForPackagingDto[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_CUSTOMER_ORDER +
            INVOKE_ORDERS_READY_FOR_PACKAGING +
            `?${prepareQueryParams(filters)}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const PackagingStatusContext = Context;
export const usePackagingStatusManager = useManager;
export const usePackagingStatus = useConsumer;
